export default "//file.bilionpass.com/japandx-web/0.0.1/static/customer_icon.e1ce2330-d05480.svg";